import React, { FC, useCallback, useEffect, useState } from "react";

import EstimatedProduction from "@assets/Estimated Production.svg";
import MonthlyBudget from "@assets/Monthly Budget.svg";
import Appointments from "@assets/Appointments.svg";

import "./monthMasterCards.scss";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import dashboardService from "@services/dashboard.service";
import { filterPayload } from "../../calendarUtils";
import Icon from "@assets/icon_config";
import moment from "moment";

const MonthMasterCards: FC<any> = () => {

    const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
    const masterMonthData = useCalenderViewStore((state) => state.masterMonthData);
    const setMasterMonthData = useCalenderViewStore((state) => state.setMasterMonthData);
    const [monthViewMasterLoader, setMonthViewMasterLoader] = useState<boolean>(false);
    const monthFilter = useCalenderViewStore((state) => state.monthFilter);
    const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);
    const setSelectedDateCalender = useCalenderViewStore((state) => state.setSelectedDateCalender);
    const setBalanceOfMonthFlag = useCalenderViewStore((state) => state.setBalanceOfMonthFlag);
    const setIsDrillDownViewSelected = useCalenderViewStore((state) => state.setIsDrillDownViewSelected);
    const setIsProfileView = useCalenderViewStore((state) => state.setIsProfileView);

    const getMonthViewMasterData = useCallback(() => {
        console.log("MonthMasterCards.getMonthViewMasterData");
        let filters = filterPayload(monthFilter);
        setMonthViewMasterLoader(true)
        let appointmentDate = selectedDateCalender.format("YYYY-MM-DD")
        dashboardService.fetchCalenderMonthViewMasterData(appointmentDate, filters).subscribe({
            next: (v) => {
                setMasterMonthData(v?.data?.data?.masterCardInfo);
                setMonthViewMasterLoader(false);
            },

            error: (e) => {
                console.log(e);
                setMonthViewMasterLoader(false);
            },
            }
        )
    }, [monthFilter, selectedDateCalender, setMasterMonthData])

    useEffect(()=> { 
        console.log("MonthMasterCards.useEffect");
        getMonthViewMasterData();
    },[selectedDateCalender, applyFilterFlag, getMonthViewMasterData]);

    const getPercentage = (percentage:any) => {
        let className =`calenderViewCard__body__extraInfo__percentage ${percentage<=0 ? "neg" : "pos"}`;
        let iconName = percentage <= 0 ? "arrowDownFilled" : "arrowUpFilled";
        return(<span className={className}><span><Icon name={iconName} /></span>{Math.abs(Math.round(percentage))}%</span>);
    }

    const selectDrillDownFromCalender = (dayDate: any) => {
        setSelectedDateCalender(moment(dayDate));
        setBalanceOfMonthFlag(true);
        setIsDrillDownViewSelected(true);
        setIsProfileView(false);
      };
    
    
    return (
        monthViewMasterLoader ? <div className="monthKPICards">
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader shimmerBG"></div>
                </div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG">
            </div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader"></div>
                </div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader"></div>
                </div>
                <div><div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo_firsttag__preloader shimmerBG" ></div><div className = "calenderViewCard__body__extraInfo_secondtag__preloader shimmerBG"></div></div>
                <div><div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo_firsttag__preloader shimmerBG" ></div><div className = "calenderViewCard__body__extraInfo_secondtag__preloader shimmerBG"></div></div>
            </div>
        </div>
        <div className="calenderViewCard">
            <div className="calenderViewCard__icon_preloader shimmerBG"></div>
            <div className="calenderViewCard__body">
                <div className="calenderViewCard__body__info">
                    <div className="calenderViewCard__body__info__title calenderViewCard__body__info__title__preloader shimmerBG"></div>
                    <div className="calenderViewCard__body__info__body__preloader"></div>
                </div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
                <div className="calenderViewCard__body__extraInfo calenderViewCard__body__extraInfo__preloader shimmerBG"></div>
            </div>
        </div>
    </div> : <div className="monthKPICards">
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={EstimatedProduction} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Estimated Production</div>
                        <div className="calenderViewCard__body__info__body">{masterMonthData?.estimatedProduction ? `$ ${Math.round(masterMonthData?.estimatedProduction).toLocaleString()}` : `NA`}</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo">{` MTD Net Production ${masterMonthData?.MTDNetProduction ? `$ ${Math.round(masterMonthData?.MTDNetProduction).toLocaleString()}`:`NA`}`}</div>
                    <div className="calenderViewCard__body__extraInfo balanceOfMonth" style={{color:"#0072e3"}} onClick={() => selectDrillDownFromCalender(selectedDateCalender)}>{`Balance Of Month ${masterMonthData?.balanceOfMonth ? `$ ${Math.round(masterMonthData?.balanceOfMonth).toLocaleString()}` : `NA`}`} </div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={EstimatedProduction} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Run Rate Production</div>
                        <div className="calenderViewCard__body__info__body">{`${masterMonthData?.runRateProduction ? `$ ${Math.round(masterMonthData?.runRateProduction).toLocaleString()}` : 'NA' }`}</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo">
                        <div>Days Passed { parseFloat(masterMonthData?.daysPassed.toFixed(2)) }</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo">
                        <div>Total Working Days { parseFloat(masterMonthData?.totalWorkingDays.toFixed(2)) }</div>
                    </div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={MonthlyBudget} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Monthly Budget</div>
                        <div className="calenderViewCard__body__info__body">{`${masterMonthData?.monthlyBudget ? `$ ${Math.round(masterMonthData?.monthlyBudget).toLocaleString()}` : `NA` }`}</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo"><div>{`EP Vs Budget ${masterMonthData?.EPVsBudget ? `$ ${Math.abs(Math.round(masterMonthData?.EPVsBudget)).toLocaleString()}` : `NA` }`} </div><div>{getPercentage(masterMonthData?.EPVsBudgetPercentage)}</div></div>
                    <div className="calenderViewCard__body__extraInfo" ><div>{`RR Vs Budget ${masterMonthData?.RRVsBudget ? `$ ${Math.abs(Math.round(masterMonthData?.RRVsBudget)).toLocaleString()}` : `NA` }`} </div><div>{getPercentage(masterMonthData?.RRVsBudgetPercentage)}</div></div>
                </div>
            </div>
            <div className="calenderViewCard">
                <div className="calenderViewCard__icon">
                    <img src={Appointments} alt=""/>
                </div>
                <div className="calenderViewCard__body">
                    <div className="calenderViewCard__body__info">
                        <div className="calenderViewCard__body__info__title">Appointments</div>
                        <div className="calenderViewCard__body__info__body">{`${masterMonthData?.appointments ? `${masterMonthData?.appointments?.toLocaleString()}` : `NA` }`}</div>
                    </div>
                    <div className="calenderViewCard__body__extraInfo">{`MTD New Patients ${masterMonthData?.MTDNewPatients ? `${masterMonthData?.MTDNewPatients?.toLocaleString()}`:`NA` } `}</div>
                    <div className="calenderViewCard__body__extraInfo">{`Scheduled New Patients ${masterMonthData?.scheduledNewPatients ? `${masterMonthData?.scheduledNewPatients?.toLocaleString()}` : `NA` }`} </div>
                </div>
            </div>
        </div>
    )
}

export default MonthMasterCards;